<template>
  <div class="funnels">
    <h1>
      Воронки
      <b-button
        style="margin-left: 20px"
        size="sm"
        @click="showAddModal = true"
        variant="primary"
      >
        <b-icon-plus />
        Додати воронку
      </b-button>
    </h1>
    <div class="d-flex funnels__main-scene">
      <div class="funnels__column">
        <div class="f-header">
          <strong> Не відсортовані </strong>
          <div class="qty">
            <b-icon-people-fill />
            {{ groups.all.length }}
          </div>
        </div>
        <div class="f-list">
          <b-overlay :show="isLoading">
            <draggable
              group="users"
              :list="groups.all"
              @change="log($event, 'all')"
            >
              <userCard
                v-for="u in groups.all"
                :key="u.email + key"
                :user="u"
              />
            </draggable>
          </b-overlay>
        </div>
      </div>

      <draggable
        v-model="funnels"
        draggable=".dragable"
        group="funnels"
        class="d-flex funnels__table"
        @start="drag = true"
        @end="updateFunnelsOrder"
        :key="funnels.length"
      >
        <div class="funnels__column dragable" v-for="f in funnels" :key="f.id">
          <div class="f-header" :style="{ borderBottomColor: f.color.hex }">
            <strong
              contenteditable
              @keyup.enter="updateFunnelName(f.uid)"
              @blur="updateFunnelName($event, f.uid)"
              >{{ f.name }}</strong
            >
            <div class="qty">
              <b-icon-people-fill />
              <span v-if="groups['id_' + f.id]">
                {{ groups["id_" + f.id].length }}
              </span>
              <span v-else>0</span>
            </div>

            <b-dropdown
              size="sm"
              variant="link"
              class="more-button"
              toggle-class="text-decoration-none"
              right
              no-caret
            >
              <template #button-content> <b-icon-three-dots /> </template>
              <b-dropdown-item
                class="more-button__action"
                @click="startEditing(f)"
              >
                <b-icon-pencil />
                Редагувати</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                class="more-button__action danger"
                @click="startRemoving(f)"
              >
                <b-icon-trash /> Видалити</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <div class="f-list">
            <b-overlay :show="isLoading">
              <draggable
                :list="groups['id_' + f.id]"
                group="users"
                @change="updateItem($event, f.id)"
              >
                <userCard
                  v-for="u in groups['id_' + f.id]"
                  :key="u.email + key"
                  :user="u"
                />
              </draggable>
            </b-overlay>
          </div>
        </div>
      </draggable>
    </div>

    <!-- modals  -->
    <b-modal
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      v-model="showAddModal"
    >
      <b-overlay
        :show="modalLoading"
        spinner-variant="primary"
        color="#fff"
        rounded="lg"
      >
        <h2 class="mb-3"><b-icon-tag /> Додати нову воронку</h2>
        <div class="py-2 my-2">
          <b-form-input
            v-model="new_funnel.name"
            placeholder="Введіть назву"
          ></b-form-input>
          <Twitter class="mt-3" v-model="new_funnel.color" />
        </div>
        <div class="pt-2 mt-2">
          <b-button
            @click="saveFunnel"
            :disabled="disableButton"
            class="w-100"
            size="lg"
            variant="primary"
          >
            Зберегти
          </b-button>
          <b-button
            @click="showAddModal = false"
            class="w-100 mt-3"
            size="md"
            variant="outline-danger"
          >
            Скасувати
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
    <b-modal
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      v-model="modals.edit"
    >
      <b-overlay
        :show="modalLoading"
        spinner-variant="primary"
        color="#fff"
        rounded="lg"
      >
        <h2 class="mb-3"><b-icon-pencil />Редагувати воронку</h2>
        <div class="py-2 my-2">
          <b-form-input
            v-model="edited_funnel.name"
            placeholder="Введіть назву"
          ></b-form-input>
          <Twitter class="mt-3" v-model="edited_funnel.color" />
        </div>
        <div class="pt-2 mt-2">
          <b-button
            @click="updateFunnel"
            class="w-100"
            size="lg"
            variant="primary"
          >
            Зберегти
          </b-button>
          <b-button
            @click="modals.edit = false"
            class="w-100 mt-3"
            size="md"
            variant="outline-danger"
          >
            Скасувати
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
    <b-modal
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      v-model="modals.remove"
    >
      <b-overlay
        :show="modalLoading"
        spinner-variant="primary"
        color="#fff"
        rounded="lg"
      >
        <h2 class="mb-3"><b-icon-trash /> Видалити воронку</h2>
        <b-alert show variant="danger">
          Усі користувачі із видаленої воронки автоматично буде перенесено у
          колонку
          <strong> Не відсортовані </strong>
        </b-alert>
        <div class="pt-2 mt-2">
          <b-button
            @click="removeFunnel"
            class="w-100"
            size="lg"
            variant="danger"
          >
            Видалити
          </b-button>
          <b-button
            @click="modals.remove = false"
            class="w-100 mt-3"
            size="md"
            variant="outline-danger"
          >
            Скасувати
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import userCard from "./funnels-user-card.vue";
import draggable from "vuedraggable";
import { Twitter } from "vue-color";
export default {
  components: {
    Twitter,
    draggable,
    userCard,
  },
  data() {
    return {
      isLoading: false,
      modalLoading: false,
      showAddModal: false,
      key: 0,
      order: [],
      funnels: [],
      new_funnel: {
        name: "",
        color: "",
      },
      edited_funnel: {},

      groups: { all: [] },
      users: [],
      modals: {
        edit: false,
        remove: false,
      },
    };
  },
  computed: {
    disableButton() {
      let disabled = false;
      return disabled;
    },
  },
  methods: {
    startEditing(funnel) {
      this.edited_funnel = Object.assign({}, funnel);
      this.modals.edit = true;
    },
    startRemoving(funnel) {
      this.edited_funnel = Object.assign({}, funnel);
      this.modals.remove = true;
    },
    async getNewId() {
      let result = await this.$api
        .get("/get/counter/?type=funnels")
        .then((data) => {
          return data;
        })
        .catch((error) => {
          return error;
        });

      return result.data.count;
    },
    async removeFunnel() {
      this.modalLoading = true;
      let result = await this.$db.delete("funnels", this.edited_funnel.uid);
      if (result.success) {
        this.$toast.warning("Воронки видалено");
        this.updateFunnelsOrder();
        this.initialFetch();
        this.modals.remove = false;
      }
      this.modalLoading = false;
    },
    async updateFunnel() {
      this.modalLoading = true;
      let result = await this.$db.update("funnels", this.edited_funnel.uid, {
        name: this.edited_funnel.name,
        color: this.edited_funnel.color,
      });
      if (result.success) {
        this.$toast.success("Воронку збережено");
        this.modals.edit = false;
        this.initialFetch();
      }
      this.modalLoading = false;
    },
    async saveFunnel() {
      this.modalLoading = true;
      let funnel = this.new_funnel;
      let id = await this.getNewId();
      funnel["id"] = id;
      let result = await this.$db.add("funnels", funnel);

      if (result.success) {
        this.$toast.success("Воронку збережено");

        this.showAddModal = false;
        this.new_funnel = {
          name: "",
          color: "#ffffff",
        };
      }

      this.funnels.push(funnel);
      await this.updateFunnelsOrder();
      this.initialFetch();

      this.modalLoading = false;
    },
    async fetchFunnels() {
      this.isLoading = true;
      let args = {
        collectionName: "funnels",
      };
      let result = await this.$db.getCollection(args);
      let funnels = result.docs;
      let sorted = [];
      this.order.forEach((key) => {
        this.groups["id_" + key] = [];
        var found = false;
        funnels = funnels.filter((item) => {
          if (!found && item.id == key) {
            sorted.push(item);
            found = true;
            return false;
          } else return true;
        });
      });
      this.funnels = sorted;

      this.isLoading = false;
      return true;
    },
    funnelExists(funnel) {
      let exists = false;

      let found = this.groups["id_" + funnel];
      if (found) {
        exists = true;
      }
      console.log(funnel, found, exists);
      return exists;
    },
    async fetchActiveUsers(filter) {
      if (filter == true) {
        this.active_users = [];
      }
      this.isLoading = true;
      let args = {
        collectionName: "users",
        where: ["role", "==", "user"],
      };

      let result = await this.$db.getCollection(args);
      result.docs.forEach((doc) => {
        console.log(doc);
        if (doc.funnel || doc.funnel == 0) {
          if (doc.funnel == "all" || !this.funnelExists(doc.funnel)) {
            this.groups.all.push(doc);
          } else {
            this.groups["id_" + doc.funnel].push(doc);
          }
        }
        if (!doc.funnel) {
          this.groups.all.push(doc);
        }
      });

      this.isLoading = false;
    },
    async fetchOrder() {
      let order = await this.$db.getDocument("funnels_settings", "order");
      this.order = order.ids;
      return true;
    },
    async updateFunnelsOrder() {
      let funnels = this.funnels.map((el) => {
        return el.id;
      });
      await this.$db.update("funnels_settings", "order", { ids: funnels });
      return true;
    },
    async updateFunnelName(event, uid) {
      let name = event.target.innerText.trim();
      let index = this.funnels.findIndex((el) => {
        return el.uid == uid;
      });
      if (
        name.trim().length > 0 &&
        this.funnels[index].name.trim() != name.trim()
      ) {
        await this.$db.update("funnels", uid, { name: name });
        this.$toast.success("Імʼя змінено");
        this.funnels[index].name = name.trim();
      }
    },
    async updateItem(evt, group) {
      if (evt.added) {
        let uid = evt.added.element.uid;
        let new_group = group;
        if (group == "all") {
          new_group = null;
        }
        let now = new Date();
        await this.$db.update("users", uid, {
          funnel: new_group,
          funnel_updated: now,
        });
        this.key++;
      }
    },
    async initialFetch() {
      await this.fetchOrder();
      await this.fetchFunnels();
      await this.fetchActiveUsers();
    },
  },
  mounted() {
    this.initialFetch();
  },
};
</script>

<style lang="scss">
.funnels {
  max-width: 100%;
  .sortable-ghost {
    & > * {
      opacity: 0;
    }
    box-shadow: none !important;
    background: rgba(var(--primary-color-rgb), 0.1);
    overflow: hidden;
    border: 2px dashed rgba(var(--primary-color-rgb), 0.4ç);
    border-radius: 8px;
  }
  &__table {
  }
  &__main-scene {
    overflow-x: scroll;
    margin-right: -60px;
    @media (max-width: 991px) {
      margin-right: -25px;
    }
  }
  &__column {
    margin-right: 20px;
    margin-bottom: 60px;
    border: 1px dotted #ccc;
    width: 280px;
    min-width: 280px;
    margin-top: 30px;
    background: #e8eaed;
    border-radius: 8px;
    .f-list {
      min-height: 300px;
    }
    .f-header {
      padding: 8px 12px 8px;
      text-align: left;
      border-bottom: 3px solid var(--primary-color);
      margin-bottom: 20px;
      position: relative;
      .more-button {
        position: absolute;
        right: 0;
        top: 6px;
        &__action {
          font-size: 12px;
          &:hover {
            background: var(--primary-color);
          }
          &.danger {
            * {
              color: #f00 !important;
              &:active {
                background: #f00;
                color: #fff !important;
                fill: #fff;
              }
            }
          }
          svg {
            margin-right: 12px;
          }
        }
        & > button {
          opacity: 0.5;
          color: #000;
          padding-left: 3px;
          padding-right: 6px;
          transition: 0.3s;
          &:hover {
            opacity: 1;
            transition: 0.3s;
          }
        }
      }
      .qty {
        font-size: 12px;
        line-height: 1;
        color: #999;
        padding-top: 6px;
      }
      cursor: pointer;
      strong {
        min-height: 20px;
        width: 200px;
        display: block;
        max-width: 100%;
        font-size: 14px;
        cursor: text;
        &:hover {
          background: rgba(var(--secondary-color-rgb), 0.1);
        }
        &:focus {
          background: rgba(var(--secondary-color-rgb), 0.4);
        }
      }
      [contenteditable] {
        white-space: nowrap;
        width: 240px;
        overflow: hidden;
      }
      [contenteditable] br {
        display: none;
      }
      [contenteditable] * {
        display: inline;
        white-space: nowrap;
      }
    }
  }
}
</style>
